
import Layout from '../../components/Layout/Layout';
import { useState, useRef, Fragment, useEffect } from 'react';
import WithdrawalServices from '../../services/WithdrawalServices';
import Toastr from '../../utils/Toastr';
import { Menu, Transition, Dialog } from '@headlessui/react'
import { HollowDotsSpinner } from 'react-epic-spinners';
import { FormatMoney } from '../../utils/formatMoney';
import { formatDate } from '../../utils/convertDate';

export default function ViewPickUp() {


    const statusStyles = {
        Active: 'bg-green-500 text-white',
        Disabled: 'bg-amber-400 text-white',
        Inactive: 'bg-orange-600 text-white',
    }
    const errors = {
        commentError: "",
        commentIsValidated: "",
        formIsSubmitting: false
    }
    const code = new URLSearchParams(window.location.search).get("code");
    const [customer, setCustomer] = useState({});
    const [imgUrl, setImgUrl] = useState("");
    const [open, setOpen] = useState(false);
    const [openReject, setRejectOpen] = useState(false);
    const cancelButtonRef = useRef(null);
    const [commentValue, setCommentValue] = useState({
        comment: ""
    });
    const [formState, setFormState] = useState(errors);
    const [primMail, setPrimMail] = useState(false);
    const [secMail, setSecMail] = useState(false);
    const [approveLoader, setApproveLoader] = useState({ loading: false });
    const [rejectLoader, setRejectLoader] = useState({ loading: false });


    const ViewCustomer = async () => {
        const customer = await WithdrawalServices.viewCashPickUp(code);
        setCustomer(customer.data);
        const response = await fetch(customer.data.bvnSelfieUrl);
        const imageBlob = await response.blob();
        const reader = new FileReader();
        reader.readAsDataURL(imageBlob);
        reader.onloadend = () => {
            const base64data = reader.result;
            setImgUrl(base64data);
        };

        // Check mailing permission
        var Mod = JSON.parse(sessionStorage.getItem("user"));
        const me = Mod.primaryModules.find((x => x === "withdrawal"));
        if (me === "withdrawal") {
            setPrimMail(true);
        }
        const sec = Mod.secondaryModules.find((x => x === "withdrawal"));
        if (sec === "withdrawal") {
            setSecMail(true);
        }
    }

    //Action Modal section
    const handleApprove = async () => {
        setOpen(true);
    }
    const handleReject = async () => {
        setRejectOpen(true);
    }

    const handleClose = () => {
        setOpen(false);

    }
    const handleRejectClose = () => {
        setRejectOpen(false);
    }

    // comment validation
    const formHandler = {
        commentHandler: (event) => {
            setCommentValue({ ...commentValue, comment: event.target.value });
            if (event.target.value.trim().length < 1) {
                setFormState({
                    ...formState,
                    commentError: "Comment cannot be empty",
                    commentIsValidated: false,
                });
                return;
            }

            setFormState({
                ...formState,
                commentError: "",
                commentIsValidated: true
            })
        },
    }

    //   Primary and secondary mailing approval
    const approve = async () => {
        setApproveLoader({ loading: true });
        const resp = primMail ?
            await WithdrawalServices.approvePickUp(code, commentValue.comment, "Primary_Approved") :
            secMail ?
                await WithdrawalServices.actionSecPickup(code, commentValue.comment, "Approved") : null;
        if (resp) {
            Toastr("success", resp.message);
            setTimeout(() => { window.location.href = "/withdrawal/pickup" }, 2000);
        }
        setApproveLoader({ loading: true });

    }
    const reject = async () => {
        setRejectLoader({ loading: true });
        const resp = primMail ?
            await WithdrawalServices.approvePickUp(code, commentValue.comment, "Rejected") :
            secMail ?
                await WithdrawalServices.actionSecPickup(code, commentValue.comment, "Rejected") : null;
        if (resp) {
            Toastr("success", resp.message);
            setTimeout(() => { window.location.href = "/withdrawal/pickup" }, 2000);
        }
        setRejectLoader({ loading: true });
    }
    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }
    useEffect(() => {
        ViewCustomer();
    }, [])
    return (<>
        <Layout title={"Cash Pickup"} pageTag={'withdrawal'} current={'/pickup/view'}>
            <main>
                <div className='max-w-7xl mx-auto px-4 sm:px-6 md:px-8'>
                    <div className='py-4'>
                        <div className="mt-1 relative rounded-md flex justify-center">
                            <img
                                className="inline-block h-28 w-28 rounded-full border-8 border-rose-600"
                                src={imgUrl} alt=""
                            />

                        </div>
                        <div className='flex justify-center'>
                            <div className='font-bold'>{customer.firstName} {customer.surname} <span className={classNames(
                                statusStyles[customer.customerStatus], "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-gray-900")}>{customer.customerStatus}</span> <br />
                                <span className='text-sm text-center ml-4 flex justify-evenly font-thin'> Username:<span className='text-green-400 font-thin'>{customer.userName}</span></span> </div>
                        </div>
                        <div className="mt-4  items-center sm:mt-0 sm:ml-16 sm:flex justify-end grid text-center relative bottom-10">
                            <p className='grid'>Authorization Code<span className='text-green-400 font-thin text-2xl'>{customer.authorizationCode}</span></p>
                        </div>
                        <div className="px-4 sm:px-6 lg:px-8">
                            <div className="sm:flex sm:items-center">
                                <div className="sm:flex-auto flex">
                                </div>

                            </div>
                            <div className="mt-8 flex flex-col">
                                <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                    <form>
                                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-zinc-200">
                                            <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                                                <div className='contents min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white'>
                                                    {/* form */}
                                                    <div className='p-6'>
                                                        <h4 className='font-bold'>NAMES</h4>
                                                        <div className='mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6'>
                                                            <div className="sm:col-span-1">
                                                                <label htmlFor="first-name" className="block text-sm font-medium text-gray-700">
                                                                    Title <span className='text-red-600'>*</span>
                                                                </label>
                                                                <div className="mt-1">
                                                                    <input type="text" name="title" value={customer.title} id="title" className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                </div>
                                                            </div>
                                                            <div className="sm:col-span-2">
                                                                <label htmlFor="firstName" className="block text-sm font-medium text-gray-700">
                                                                    First name <span className='text-red-600'>*</span>
                                                                </label>
                                                                <div className="mt-1">
                                                                    <input type="text" name="firstName" value={customer.firstName} id="firstName" className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                </div>
                                                            </div>
                                                            <div className="sm:col-span-1">
                                                                <label htmlFor="middleName" className="block text-sm font-medium text-gray-700">
                                                                    Middle Name <span className='text-red-600'>*</span>
                                                                </label>
                                                                <div className="mt-1">
                                                                    <input type="text" name="middleName" value={customer.middleName} id="middleName" className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                </div>
                                                            </div>
                                                            <div className="sm:col-span-2">
                                                                <label htmlFor="lastName" className="block text-sm font-medium text-gray-700">
                                                                    Last Name <span className='text-red-600'>*</span>
                                                                </label>
                                                                <div className="mt-1">
                                                                    <input type="text" name="lastName" id="lastName" value={customer.surname} className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                                                <div className='contents min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white'>
                                                    {/* form */}
                                                    <div className='px-6 py-6'>
                                                        <h4 className='font-bold'>PERSONAL INFORMATION</h4>
                                                        <div className='mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6'>

                                                            <div className="sm:col-span-2">
                                                                <label htmlFor="dob" className="block text-sm font-medium text-gray-700">
                                                                    Date of Birth
                                                                </label>
                                                                <div className="mt-1">
                                                                    <input type="text" name="dob" id="dob" value={formatDate(customer.dateOfBirth)} className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                </div>
                                                            </div>
                                                            <div className="sm:col-span-1">
                                                                <label htmlFor="gender" className="block text-sm font-medium text-gray-700">
                                                                    Gender
                                                                </label>
                                                                <div className="mt-1">
                                                                    <input type="text" name="gender" id="gender" value={customer.gender} className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                </div>
                                                            </div>
                                                            <div className="sm:col-span-1">
                                                                <label htmlFor="maritalStatus" className="block text-sm font-medium text-gray-700">
                                                                    Marital Status
                                                                </label>
                                                                <div className="mt-1">
                                                                    <input type="text" name="maritalStatus" id="maritalStatus" value={customer.maritalStatus} className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                </div>
                                                            </div>

                                                            <div className="sm:col-span-2">
                                                                <label htmlFor="nin" className="block text-sm font-medium text-gray-700">
                                                                    NIN
                                                                </label>
                                                                <div className="mt-1">
                                                                    <input type="text" name="nin" id="nin" value={customer.nin} className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                </div>
                                                            </div>
                                                            <div className="sm:col-span-2">
                                                                <label htmlFor="phone" className="block text-sm font-medium text-gray-700">
                                                                    Phone Number
                                                                </label>
                                                                <div className="mt-1">
                                                                    <input type="text" name="phone" id="phone" value={customer.phoneNumber} className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                </div>
                                                            </div>
                                                            <div className="sm:col-span-2">
                                                                <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                                                    Email
                                                                </label>
                                                                <div className="mt-1">
                                                                    <input type="text" name="email" value={customer.emailAddress} id="email" className="shadow-sm bg-gray-100 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                                                <div className='contents min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white'>
                                                    {/* form */}
                                                    <div className='p-6'>
                                                        <h4 className='font-bold'>WITHDRAWAL DETAILS</h4>
                                                        <div className='mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6'>
                                                            <div className="sm:col-span-2">
                                                                <label htmlFor="thirdpartyName" className="block text-sm font-medium text-gray-700">
                                                                    Withdrawal Amount
                                                                </label>
                                                                <div className="mt-1">
                                                                    <input type="text" name="thirdpartyName" id="thirdpartyName" value={customer.amount === null ? "N/A" : FormatMoney(customer.amount)} autocomplete="given-name" className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                </div>
                                                            </div>
                                                            <div className="sm:col-span-2">
                                                                <label htmlFor="kinEmail" className="block text-sm font-medium text-gray-700">
                                                                    Branch Name
                                                                </label>
                                                                <div className="mt-1">
                                                                    <input type="text" name="kinEmail" id="kinEmail" value={customer.branchName} autocomplete="given-name" className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                </div>
                                                            </div>
                                                            <div className="sm:col-span-2">
                                                                <label htmlFor="relationship" className="block text-sm font-medium text-gray-700">
                                                                    Account Number
                                                                </label>
                                                                <div className="mt-1">
                                                                    <input type="text" name="relationship" id="relationship" autocomplete="given-name" value={customer.accountNumber} className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                                                <div className='contents min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white'>
                                                    {/* form */}
                                                    <div className='p-6'>
                                                        <h4 className='font-bold'>THIRD-PARTY INFORMATION</h4>
                                                        <div className='mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6'>
                                                            <div className="sm:col-span-6">
                                                                <label htmlFor="thirdpartyName" className="block text-sm font-medium text-gray-700">
                                                                    Full Name
                                                                </label>
                                                                <div className="mt-1">
                                                                    <input type="text" name="thirdpartyName" id="thirdpartyName" value={customer.thirdpartyName} className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                </div>
                                                            </div>
                                                            <div className="sm:col-span-2">
                                                                <label htmlFor="kinEmail" className="block text-sm font-medium text-gray-700">
                                                                    ID Type
                                                                </label>
                                                                <div className="mt-1">
                                                                    <input type="text" name="kinEmail" id="kinEmail" value={customer.thirdpartyVerificationType} className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                </div>
                                                            </div>
                                                            <div className="sm:col-span-2">
                                                                <label htmlFor="relationship" className="block text-sm font-medium text-gray-700">
                                                                    Phone Number
                                                                </label>
                                                                <div className="mt-1">
                                                                    <input type="text" name="relationship" id="relationship" value={customer.thirdpartyPhoneNumber} className="bg-gray-100 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className=' bg-white p-6'>
                                                <p className="text-red-400 letter-spacing font-semibold">Kindly approve after giving cash to the customer</p>
                                                <div className='flex justify-end'>
                                                    {(customer.cashPickupStatus === "Initiated") || (customer.cashPickupStatus === "Primary_Approved") ?
                                                        <>
                                                            {customer.cashPickupStatus === "Approved" || customer.cashPickupStatus === "Rejected" ?
                                                                "" :
                                                                <>
                                                                    <button type='button' onClick={() => handleApprove()} className='btn-secondary  align-center flex justify-center items-center rounded-md border mr-4 px-8 py-2 text-sm font-medium text-black shadow-sm  sm:w-auto'>
                                                                        Approve
                                                                    </button>

                                                                    <button type="button" onClick={() => handleReject()} className=" btn-primary align-center flex justify-center items-center rounded-md border border-transparent  px-8  py-2 text-sm font-medium text-white shadow-sm  sm:w-auto">
                                                                        Reject
                                                                    </button>
                                                                </>
                                                            }
                                                        </>
                                                        : ""
                                                    }

                                                </div>

                                            </div>
                                        </div>

                                    </form>

                                </div>
                            </div>
                        </div>
                        {/* Modal */}
                        <Transition.Root show={open} as={Fragment}>
                            <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={handleClose}>
                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0"
                                    enterTo="opacity-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100"
                                    leaveTo="opacity-0"
                                >
                                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                                </Transition.Child>

                                <div className="fixed z-10 inset-0 overflow-y-auto">
                                    <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                                        <Transition.Child
                                            as={Fragment}
                                            enter="ease-out duration-300"
                                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                                            leave="ease-in duration-200"
                                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                        >
                                            <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-xs sm:w-full sm:p-6">
                                                <div>
                                                    <div className="mt-3 text-center sm:mt-5">
                                                        <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
                                                            Hey, wait!!
                                                        </Dialog.Title>
                                                        <div className="mt-2">
                                                            <p className="text-sm text-gray-500">
                                                                Are you sure you want  approve this request?
                                                            </p>
                                                            <form>
                                                                <label htmlFor="comment" className="text-left mt-2 block text-sm font-medium text-gray-700">Comment</label>
                                                                <div className="mt-1">
                                                                    <input
                                                                        id="comment"
                                                                        name="comment"
                                                                        type="text"
                                                                        placeholder='Enter comment'
                                                                        value={commentValue.comment}
                                                                        onChange={formHandler.commentHandler}
                                                                        required
                                                                        className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                                    />
                                                                    {!formState.commentIsValidated && formState.commentError && (
                                                                        <div className="text-red-800">
                                                                            {formState.commentError}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </form>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="mt-5 sm:mt-6 sm:flex sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                                                    {approveLoader.loading === false ?
                                                        <button
                                                            type="button"
                                                            className="w-full inline-flex justify-center rounded-md border border-gray-900 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-900  sm:col-start-2 sm:text-sm"
                                                            onClick={() => approve()}
                                                        >
                                                            Yes, I do
                                                        </button> : <HollowDotsSpinner size={15} color="#4D627E" />
                                                    }
                                                    <button
                                                        type="button"
                                                        className="mt-3 w-full inline-flex justify-center rounded-md border bg-dark border-gray-300 shadow-sm px-4 py-2  text-base font-medium text-white btn-primary sm:mt-0 sm:col-start-1 sm:text-sm"
                                                        onClick={() => setOpen(false)}

                                                        ref={cancelButtonRef}
                                                    >
                                                        No, I dont
                                                    </button>
                                                </div>
                                            </Dialog.Panel>
                                        </Transition.Child>
                                    </div>
                                </div>
                            </Dialog>
                        </Transition.Root>
                        <Transition.Root show={openReject} as={Fragment}>
                            <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={handleRejectClose}>
                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0"
                                    enterTo="opacity-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100"
                                    leaveTo="opacity-0"
                                >
                                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                                </Transition.Child>

                                <div className="fixed z-10 inset-0 overflow-y-auto">
                                    <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                                        <Transition.Child
                                            as={Fragment}
                                            enter="ease-out duration-300"
                                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                                            leave="ease-in duration-200"
                                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                        >
                                            <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-xs sm:w-full sm:p-6">
                                                <div>
                                                    <div className="mt-3 text-center sm:mt-5">
                                                        <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
                                                            Hey, wait!!
                                                        </Dialog.Title>
                                                        <div className="mt-2">
                                                            <p className="text-sm text-gray-500">
                                                                Are you sure you want reject this request?
                                                            </p>
                                                            <form>
                                                                <label htmlFor="comment" className="text-left mt-2 block text-sm font-medium text-gray-700">Comment</label>
                                                                <div className="mt-1">
                                                                    <input
                                                                        id="comment"
                                                                        name="comment"
                                                                        type="text"
                                                                        placeholder='Enter comment'
                                                                        value={commentValue.comment}
                                                                        onChange={formHandler.commentHandler}
                                                                        required
                                                                        className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                                    />
                                                                    {!formState.commentIsValidated && formState.commentError && (
                                                                        <div className="text-red-800">
                                                                            {formState.commentError}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </form>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="mt-5 sm:mt-6 sm:flex sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                                                    {rejectLoader.loading === false ?
                                                        <button
                                                            type="button"
                                                            className="w-full inline-flex justify-center rounded-md border border-gray-900 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-900  sm:col-start-2 sm:text-sm"
                                                            onClick={() => reject()}
                                                        >
                                                            Yes, I do
                                                        </button> : <HollowDotsSpinner size={15} color="#4D627E" />
                                                    }

                                                    <button
                                                        type="button"
                                                        className="mt-3 w-full inline-flex justify-center rounded-md border bg-dark border-gray-300 shadow-sm px-4 py-2  text-base font-medium text-white btn-primary sm:mt-0 sm:col-start-1 sm:text-sm"
                                                        onClick={() => setRejectOpen(false)}
                                                        ref={cancelButtonRef}
                                                    >
                                                        No, I dont
                                                    </button>
                                                </div>
                                            </Dialog.Panel>
                                        </Transition.Child>
                                    </div>
                                </div>
                            </Dialog>
                        </Transition.Root>
                    </div>
                </div>
            </main>
        </Layout>

    </>);
}